import {
  CLEAR_CURRENT_USER_GROUP,
  SET_CURRENT_USER_GROUP,
} from "../constants/actions";

const initialState = {
  name: null,
  id: null,
  memberCount: null,
  source: null,
  lastUpdatedAt: null,
};

export default function currentUserGroup(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER_GROUP:
      if (!action.payload) {
        return state;
      }

      return {
        ...state,
        name: action.payload.name ?? state.name,
        id: action.payload.id ?? state.id,
        memberCount: action.payload.memberCount ?? state.memberCount,
        source: action.payload.source ?? state.source,
        lastUpdatedAt: Date.now(),
      };

    case CLEAR_CURRENT_USER_GROUP:
      return initialState;

    default:
      return state;
  }
}
